import React from 'react';

//the context to save the mqtt client
export const MqttClientContext = React.createContext({
    mqttClient: null,
    source: null
});

